export default {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'logInOutController',
    template: require('../views/logInOut.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/logInOut.component.js